export default __webpack_public_path__ + "static/media/spacefit2.334e2785.jpg";